export const environment = {
	production: false,
	authUrl: 'https://b3.s6eur.com',
    pyUrl: 'https://b2.s6eur.com',
    phpUrl: 'https://b1.s6eur.com',
    phpLaravelUrl: 'https://b4.s6eur.com',
	paymentAppUrl: 'https://packagetest-jtn43sd.snapfix.com',
	qrAppUrl: 'https://afd2bda-qrtest.snapfix.com',
	onboardingAppUrl: 'https://setuptest.snapfix.com'
};
